import { request } from './client';
import type {
  PlayerConnectionWithStats,
  CreateConnectionInput,
  UpdateConnectionInput,
} from '../types';

export interface SearchConnectionsInput {
  query?: string;
  limit?: number;
  offset?: number;
}

export interface SearchConnectionsResult {
  connections: PlayerConnectionWithStats[];
  total: number;
  limit: number;
  offset: number;
}

export const connectionsApi = {
  // List all connections for the current user (online users only)
  list: (): Promise<PlayerConnectionWithStats[]> =>
    request('/api/squareup/connections'),

  // Search connections with pagination (online users only)
  search: (input: SearchConnectionsInput = {}): Promise<SearchConnectionsResult> => {
    const params = new URLSearchParams();
    if (input.query) params.set('q', input.query);
    if (input.limit) params.set('limit', input.limit.toString());
    if (input.offset) params.set('offset', input.offset.toString());
    const queryString = params.toString();
    return request(`/api/squareup/connections/search${queryString ? `?${queryString}` : ''}`);
  },

  // Create a new connection
  create: (input: CreateConnectionInput): Promise<PlayerConnectionWithStats> =>
    request('/api/squareup/connections', {
      method: 'POST',
      body: input,
    }),

  // Update a connection's nickname or notes
  update: (connectionId: string, input: UpdateConnectionInput): Promise<PlayerConnectionWithStats> =>
    request(`/api/squareup/connections/${connectionId}`, {
      method: 'PATCH',
      body: input,
    }),

  // Delete a connection
  delete: (connectionId: string): Promise<void> =>
    request(`/api/squareup/connections/${connectionId}`, {
      method: 'DELETE',
    }),

  // Get suggested connections based on board history
  getSuggestions: (limit: number = 10): Promise<PlayerConnectionWithStats[]> =>
    request(`/api/squareup/connections/suggestions?limit=${limit}`),
};
